import { defineComponent as _defineComponent } from 'vue'

import { BasketPlan } from '@/models/basket_plans/basket_plan_model';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { Icons } from '@/font-awesome';
import { BasketPlanStatus } from '@/models/basket_plans/basket_plan_status_enum';
import FormatUtils from '@/utils/format_utils';
import moment from 'moment';


export default /*@__PURE__*/_defineComponent({
  __name: 'BasketPlanStatus',
  props: {
    basketPlan: { type: Object, required: true },
    isVisible: { type: Boolean, required: false },
    size: { type: String, required: false },
    sizeLine: { type: String, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

const isVisible = props.isVisible;

const icons = [
  Icons.imported.faBoxOpen,
  Icons.imported.faFileCircleCheck,
  Icons.imported.faHouseCircleCheck,
];

const __returned__ = { props, isVisible, icons, get FontAwesomeIcon() { return FontAwesomeIcon }, get BasketPlanStatus() { return BasketPlanStatus }, get FormatUtils() { return FormatUtils }, get moment() { return moment } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})